export const nameDisplayInput = document.querySelector('#name-display');
export const orgDisplayInput = document.querySelector('#org-display');
export const bioDisplayInput = document.querySelector('#bio-display');
export const emailDisplayInput = document.querySelector('#email-display');
export const phoneDisplayInput = document.querySelector('#phone-display');
export const qrContainer = document.querySelector('#qr-container');

export function setupProfileEls() {
    if (window.location.pathname !== "/") {
        return;
    }

    function renderCode() {
        const codeEl = document.getElementById("qrcode");
        codeEl.innerHTML = '';

        new QRCode(codeEl, {
            text: localStorage.getItem('bio'),
            width: 250,
            height: 250,
            colorDark: "#3d5c5c",
            colorLight: "#faf9f9",
        });

        codeEl.setAttribute('title', 'Profile QR Code');
        qrContainer.style.display = 'block';
    }

    function setInputValues(bioObject) {
        nameDisplayInput.value = bioObject.name;
        orgDisplayInput.value = bioObject.org;
        bioDisplayInput.value = bioObject.bio;
        emailDisplayInput.value = bioObject.email;
        phoneDisplayInput.value = bioObject.phone;
    }

    if (localStorage.getItem('bio')) {
        const bioObject = JSON.parse(localStorage.getItem('bio'));

        setInputValues(bioObject);
        renderCode();

        if (!bioObject.name) {
            qrContainer.style.display = 'none';
        }
    }

    function saveProfileDataLocal() {

        const bioObject = {};
        bioObject.name = nameDisplayInput.value;
        bioObject.org = orgDisplayInput.value;
        bioObject.bio = bioDisplayInput.value;
        bioObject.email = emailDisplayInput.value;
        bioObject.phone = phoneDisplayInput.value;

        localStorage.setItem('bio', JSON.stringify(bioObject));
        setInputValues(bioObject);
        renderCode();
        if (!bioObject.name) {
            qrContainer.style.display = 'none';
        }


    }

    nameDisplayInput.addEventListener('change', saveProfileDataLocal);
    orgDisplayInput.addEventListener('change', saveProfileDataLocal);
    bioDisplayInput.addEventListener('change', saveProfileDataLocal);
    emailDisplayInput.addEventListener('change', saveProfileDataLocal);
    phoneDisplayInput.addEventListener('change', saveProfileDataLocal);
}